export const BASE_API_URL = `case-studies/v1/cases`;
export const GROUPS_API_URL = `case-studies/v1/groups`;
export const SETTINGS_MODAL = 'SETTINGS_MODAL';
export const CONTENT_TYPE_TABLE_NAME = 'hs_internal_case_study';